import requestService from '../requestService';
import store from '@/store';

export default {
    async getRoles(){
        const response = await requestService.get(`/roles?type=${process.env.VUE_APP_TYPE}&lang=${store.getters.loggedUser.locale}`,{
            headers: {Authorization : `Bearer ${store.getters.loggedUser.token}`}
        })
        return response?.data
    },
};